<template>
  <div class="app-skeleton" :class="{ 'app-skeleton--inline': inline }">
    <v-skeleton-loader
      v-for="n in count"
      :key="n"
      class="app-skeleton__item"
      :type="type"
      :tile="tile"
      :boilerplate="boilerplate"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
export default {
  name: 'AppSkeleton',

  props: {
    type: {
      type: String,
      default: 'text',
    },

    count: {
      type: Number,
      default: 1,
    },

    tile: {
      type: Boolean,
      default: false,
    },

    boilerplate: {
      type: Boolean,
      default: false,
    },

    inline: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.app-skeleton {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.app-skeleton--inline {
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.app-skeleton__item ::v-deep .v-skeleton-loader__bone {
  border-radius: 8px;
}

.app-skeleton__item ::v-deep .v-skeleton-loader__avatar {
  border-radius: 50%;
}
</style>
